/**
 * Family status API service (PERSONAL accounts — Family Pulse widget).
 *
 * Reads every family member's current self-set status. Writes go through the
 * generic /user-preferences endpoint (context = FAMILY_STATUS, USER scope) — see
 * useFamilyStatus. Personal-only; the server verifies accountType === PERSONAL.
 *
 * @module lib/api/family-status.api
 */

import type { FamilyMemberStatus } from '@scrambl/shared';

import { apiClient } from './api-client';
import { createSingletonApi } from './singleton-factory';

class FamilyStatusApi {
  /** GET /family/status → one entry per active member (status null when unset). */
  async getStatuses(): Promise<FamilyMemberStatus[]> {
    return apiClient<FamilyMemberStatus[]>('/family/status');
  }
}

export const familyStatusApi = createSingletonApi(FamilyStatusApi);
